import { Tooltip } from "ui-kit-v2/src/tooltip/tooltip";
import { Tag } from "ui-kit-v2/src/tag/tag";
import { _ } from "i18n";
import { getColor } from "common/src/players-grid/components/DataGrid/functions";
import { ColumnEnum } from "common/src/players-grid/types";

interface CoachReviewsRatingTagProps {
	rating: number;
	position: string | null;
}

export const CoachReviewsRatingTag = ({ rating, position }: CoachReviewsRatingTagProps) => {

	const tileColors = position == null ? undefined : getColor(position, ColumnEnum.rating, rating, false);
	const hasTileColors = tileColors !== undefined && tileColors.background !== "" && tileColors.color !== "";

	return (
		<Tooltip label={_("game.coachReviews.rating.tooltip")} position="bottom" interactive={false}>
			<Tag
				variant="secondary"
				palette="neutral"
				style={hasTileColors ? { background: tileColors.background, color: tileColors.color } : undefined}
			>
				{rating}
			</Tag>
		</Tooltip>
	);
};
